import { render, staticRenderFns } from "./BlaBlaBla.vue?vue&type=template&id=251471f4&scoped=true"
import script from "./BlaBlaBla.vue?vue&type=script&lang=js"
export * from "./BlaBlaBla.vue?vue&type=script&lang=js"
import style0 from "./BlaBlaBla.vue?vue&type=style&index=0&id=251471f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251471f4",
  null
  
)

export default component.exports